import { useEffect } from 'react';
import Hero from '../components/Hero';
import Credibility from '../components/Credibility';
import DesignPhilosophy from '../components/DesignPhilosophy';
import PersonalNote from '../components/PersonalNote';
import ClosingCTA from '../components/ClosingCTA';

function Home() {
  useEffect(() => {
    document.title = "Deepali Agrawal — Visual Designer";
  }, []);

  return (
    <div>
      <Hero />
      <Credibility />
      <DesignPhilosophy />
      <PersonalNote />
      <ClosingCTA />
    </div>
  );
}

export default Home;